import {createStore, applyMiddleware} from 'redux';
import createSagaMiddleware, {END} from 'redux-saga';
import {composeWithDevTools} from 'redux-devtools-extension';
import pluginRegistry from 'epic-diesel-common/src/plugin/PluginProvider';
import sagas from './sagas';
import {createReducer, bootstrap} from './reducers';

const sagaMiddleware = createSagaMiddleware();

export function configureStore(initialState) {
    const providedReducers = pluginRegistry.getReducerMap();
    const middlewares = [sagaMiddleware];

    let middlewareEnhancer = applyMiddleware(...middlewares);

    if (process.env.NODE_ENV === 'development') {
        middlewareEnhancer = composeWithDevTools(middlewareEnhancer);
    }

    const store = createStore(createReducer(providedReducers), initialState, middlewareEnhancer);

    // API Required for react SSR
    //@ts-ignore
    store.sagas = sagaMiddleware.run(sagas);
    //@ts-ignore
    store.close = () => {
        store.dispatch(END);
    };

    return store;
}

/**
 * A function to take a data preload (from the server) and transform it into a redux store with reducers
 * @param {*} bootstrapData
 */
export function bootstrapStore(bootstrapData) {
    const providedReducers = pluginRegistry.getReducers();
    const initialState = bootstrap(bootstrapData, providedReducers);
    return configureStore(initialState);
}
